import Link from 'next/link';
import { cn } from '@/service/utils/cn';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';
import { getCommonPhoneFormatURI } from '@/service/utils/getCommonPhoneFormat';

export const CallToBook = ({ className }: { className?: string }) => {
    const { phone, texts } = usePartnerStore();

    if (!phone) {
        return <></>;
    }

    return (
        <Link
            href={getCommonPhoneFormatURI(phone)}
            target="_blank"
            className={cn(
                'inline-flex h-[33px] flex-shrink-0 items-center justify-center rounded-2xl border-[0.7px] border-brand bg-ash px-1 dark:bg-dark-3',
                className
            )}
            prefetch={false}
            data-test-id="calendar-call-to-book"
        >
            <img src="/icon/Call.svg" alt="Call" />
            <span className="tx-medium-medium max-w-[80%] overflow-hidden text-ellipsis whitespace-nowrap text-gray-2 text-opacity-50 dark:text-gray-3">
                {texts?.['Call to Book'] || 'Call to book'}
            </span>
        </Link>
    );
};
